import { defineStore } from 'pinia';
import { ref } from 'vue';

const useDocumentRefreshStore = defineStore('documentRefresh', () => {
  const refreshTrigger = ref(0);
  const lastUploadTime = ref<Date | null>(null);

  const triggerDocumentRefresh = () => {
    refreshTrigger.value += 1;
    lastUploadTime.value = new Date();
  };

  return {
    refreshTrigger,
    lastUploadTime,
    triggerDocumentRefresh,
  };
});

export default useDocumentRefreshStore;
